import React, { Component } from 'react';
import PropTypes from 'prop-types';
import s from './Cross.module.css';

class Cross extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
  };

  render = () => {
    const { onClick } = this.props;

    return (
      <div
        className={s.root}
        onClick={onClick}
        onKeyPress={onClick}
        title="Close"
        role="presentation"
      />
    );
  };
}

export default Cross;
